/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class BlockedSignupDomainEntity extends Entity {
  createdAt: string | null = null;
  domain: string | null = null;
  id: string = '';
  updatedAt: string | null = null;
  static override key = 'BlockedSignupDomain';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'BlockedSignupDomain' in input
    ) {
      const { BlockedSignupDomain: wrapped, ...rest } = input as {
        BlockedSignupDomain: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}